import { configureStore } from '@reduxjs/toolkit';
import experimentDesignReducer from './slices/experimentDesignSlice';
import sampleReducer from './slices/sampleSlice';
import groupReducer from './slices/groupSlice';
import ltecBatchReducer from './slices/ltecBatchSlice';
import perfusionReducer from './slices/perfusionSlice';

// Load state from localStorage (safe for SSR)
const loadState = () => {
  if (typeof window === 'undefined') {
    return undefined; // Return undefined during SSR
  }
  try {
    const serializedState = localStorage.getItem('appState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error('Error loading state from localStorage:', err);
    return undefined;
  }
};

// Save state to localStorage (safe for SSR)
const saveState = (state) => {
  if (typeof window === 'undefined') {
    return; // Don't save during SSR
  }
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('appState', serializedState);
  } catch (err) {
    console.error('Error saving state to localStorage:', err);
  }
};

const persistedState = loadState();

const store = configureStore({
  reducer: {
    experimentDesign: experimentDesignReducer,
    samples: sampleReducer,
    groups: groupReducer,
    ltecBatch: ltecBatchReducer,
    perfusion: perfusionReducer,
  },
  preloadedState: persistedState,
});

// Subscribe to store changes and save to localStorage
store.subscribe(() => {
  saveState({
    experimentDesign: store.getState().experimentDesign,
    samples: store.getState().samples,
    groups: store.getState().groups,
    ltecBatch: store.getState().ltecBatch,
    // Don't persist perfusion data as it's fetched fresh and should be cache-managed
    // perfusion: store.getState().perfusion,
    // Don't persist sample data as it could be large and is fetched from API
    // Only persist sample data if needed in the future
    // sample: store.getState().sample,
  });
});

export default store;
